import { FC } from 'react';
import { Box, Button, Typography } from '@mui/material';
import { ErrorOutline, KeyboardBackspace } from '@mui/icons-material';
import { useNavigate } from 'react-router';
import { TOrderErrorProps } from './types';

export const OrderError: FC<TOrderErrorProps> = ({ text, linkText, link }) => {
	const navigate = useNavigate();
	return (
		<Box
			sx={{
				display: 'flex',
				flexDirection: 'column',
				justifyContent: 'center',
				alignItems: 'center',
				height: '320px',
				width: '100%',
				color: '#016196',
				fontSize: '24px',
				fontWeight: 'bold',
				gap: 4,
			}}
		>
			<ErrorOutline
				fontSize="large"
				sx={{
					// color: '#016196',
					fontSize: '64px',
					fontWeight: 'bold',
				}}
			/>
			<Typography
				variant="h5"
				color="primary"
				sx={{
					fontSize: '2rem',
					fontWeight: 'bold',
				}}
			>
				{text}
			</Typography>
			<Box>
				{/* <Divider sx={{ mt: 2, mb: 2 }} flexItem /> */}
				<Typography>
					<Button
						onClick={() => navigate(link)}
						color="primary"
						sx={{
							textTransform: 'none',
							fontSize: '1.5rem',
							fontWeight: 'bold',
						}}
					>
						<KeyboardBackspace sx={{ mr: 1 }} />
						{linkText}
					</Button>
				</Typography>
			</Box>
		</Box>
	);
};
